module.exports = __webpack_public_path__ + "static/media/friend-bottom-p6.f7b4e47f.png";